
export default {
  props: {
    rows: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: '#f8f8f8'
    },
    isNegativeWave: {
      type: Boolean,
      required: false,
      default: false
    },
    isProductWaves: {
      type: Boolean,
      required: false,
      default: false
    },
    isNewsletterWaves: {
      type: Boolean,
      required: false,
      default: false
    },
    desktopOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    rowElements() {
      var list = []
      for (var i = 1; i <= this.rows * 2; i++) {
        list.push(i)
      }
      return list
    }
  }
}
